export default __webpack_public_path__ + "188820e6c3b390f2b0d19b6fb1b4cfb1.svg";